import React, { Dispatch, SetStateAction } from "react"
import { Order, OrderHistory } from "lib/types/generated/graphql-types"
import { Cancellation } from "../../../../classes/order/Cancellation"
import PendingCancellation from "./PendingCancellation"
import FailedCancellation from "./FailedCancellation"
import OngoingCancellation from "./OngoingCancellation"

type Props = {
  order: Order
  refetch: () => void
  orderHistory: OrderHistory
  setShowCancelPopup: Dispatch<SetStateAction<boolean>>
}

const CancelOrder = ({ order, refetch, orderHistory, setShowCancelPopup }: Props) => {
  const cancellations = new Cancellation(order.Cancellations)
  return (
    <>
      {cancellations.pending() && (
        <PendingCancellation
          pendingCancellation={cancellations.getPendingCancellation()}
          orderRefetch={refetch}
        />
      )}
      {cancellations.failed() && (
        <FailedCancellation
          failedCancellation={cancellations.getFailedCancellation()}
          orderId={order.id}
          refetch={refetch}
          orderHistory={orderHistory.history}
        />
      )}
      {cancellations.onGoing() && (
        <OngoingCancellation
          setShowCancelPopup={setShowCancelPopup}
          ongoingCancellation={cancellations.getOngoingCancellation()}
        />
      )}
    </>
  )
}

export default CancelOrder
